import Box from "@mui/material/Box";
import BChart from "../charts/BChart";
import Stack from "@mui/material/Stack";
import useScreenSize from "../../context/ScreenContext";
import MainCard from "../../components/Layouts/MainCard";
import { MainText, MainTitle } from "../../data/style/Style";
import { WORKOUT_TYPES_DATA } from "../../data/assets/arrays";

const ResultBarChart = ({ label, minWidth, type, dateRangeId }) => {
  const { size, mobileDevice } = useScreenSize();
  let [width] = size;
  const ICON = WORKOUT_TYPES_DATA.find((item) => item.id === type).icon;

  return (
    <Box
      width={mobileDevice || width < 615 ? "100%" : "19%"}
      minWidth={"260px"}
    >
      <MainCard>
        <Stack height={"28vh"} minHeight={"220px"} minWidth={minWidth} gap={1}>
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <MainText>{ICON}</MainText>
            <Stack>
              <MainTitle>{label}</MainTitle>
            </Stack>
          </Stack>
          <BChart dateRange={dateRangeId} type={type} />
        </Stack>
      </MainCard>
    </Box>
  );
};

export default ResultBarChart;
